if (!customElements.get('zs-accessory-recommendations')) {
  class ZeeksackAccessoryRecommendations extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('.js-product') || this.closest('.cc-main-product');
      this.context = this.main?.querySelector('.zs-category-cross-sell, .zs-bundle-intro');
      this.onVariant = (event) => {
        if (event.target.closest('quick-add-drawer')) return;
        if (this.context?.classList.contains('zs-bundle-intro')) return;
        const options = event.detail?.variant?.options;
        if (options) this.update(options.find((value) => /Organizer|Underseat|Cabin|Rolltop|Weekender/i.test(value)) || '');
      };
      this.main?.addEventListener('on:variant:change', this.onVariant);
      this.update(this.dataset.initialModel || '');
    }
    disconnectedCallback() {
      this.main?.removeEventListener('on:variant:change', this.onVariant);
    }
    static matches(candidate, selected) {
      if (!selected) return true;
      const family = selected.match(/Organizer|Underseat|Cabin|Rolltop|Weekender/i)?.[0];
      if (!family || !candidate.toLowerCase().includes(family.toLowerCase())) return false;
      if (family.toLowerCase() === 'rolltop') return true;
      const sizes = selected.match(/\d+L/g) || [];
      return !sizes.length || sizes.some((size) => candidate.split(/[\s/]+/).includes(size));
    }
    update(model) {
      if (this.context) this.context.dataset.zsSelectedModel = model;
      const packageModels = this.dataset.zsBundleModels ? this.dataset.zsBundleModels.split('|') : [model];
      let visible = 0;
      this.querySelectorAll('li[data-zs-models]').forEach((card) => {
        const models = JSON.parse(card.dataset.zsModels);
        card.hidden = models.length > 0 && !models.some((candidate) => packageModels.some((packageModel) => ZeeksackAccessoryRecommendations.matches(candidate, packageModel)));
        if (!card.hidden) visible += 1;
      });
      this.hidden = visible === 0;
      const list = this.querySelector('ul');
      if (list) list.scrollLeft = 0;
    }
  }
  customElements.define('zs-accessory-recommendations', ZeeksackAccessoryRecommendations);
}

if (!customElements.get('zs-bundle-saving')) {
  class ZeeksackBundleSaving extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('.js-product');
      this.onVariant = (event) => {
        if (event.target.closest('quick-add-drawer')) return;
        const variant = event.detail?.variant;
        const saving = variant ? Number(variant.compare_at_price || 0) - Number(variant.price) : 0;
        this.hidden = saving <= 0;
        if (saving > 0) {
          const money = new Intl.NumberFormat('sv-SE', {style:'currency', currency:this.dataset.currency || 'SEK', minimumFractionDigits:0, maximumFractionDigits:2}).format(saving / 100);
          this.textContent = 'Du sparar ' + money + ' på paketet.';
        }
      };
      this.main?.addEventListener('on:variant:change', this.onVariant);
    }
    disconnectedCallback() { this.main?.removeEventListener('on:variant:change', this.onVariant); }
  }
  customElements.define('zs-bundle-saving', ZeeksackBundleSaving);
}
